export const CACHE_KEY_AC_ENERGY_CONSUMERS = 'ac-energy-consumers'
export const CACHE_KEY_AC_GENERATORS = 'ac-generators'
export const CACHE_KEY_DC_STORAGE = 'dc-storage'
export const CACHE_KEY_ALERT_COUNTS = 'alert-counts'
export const CACHE_KEY_ALERT_HISTORY = 'alert-history'
export const CACHE_KEY_ALERTS = 'alerts'
export const CACHE_KEY_AMBIENT_TEMPERATURE = 'ambient-temperature'
export const CACHE_KEY_ASSET_FAMILY = 'asset-family'
export const CACHE_KEY_ASSET_FAMILY_ALERT_DEFINITIONS = 'asset-family-alert-definitions'
export const CACHE_KEY_ASSET_FAMILY_GROUP_ASSET_FAMILIES = 'asset-family-group-asset-families'
export const CACHE_KEY_ASSET_FAMILY_GROUPS = 'asset-family-groups'
export const CACHE_KEY_ASSET_FAMILY_SETTINGS = 'asset-family-settings'
export const CACHE_KEY_ASSET_FAMILY_TYPES = 'asset-family-types'
export const CACHE_KEY_BATTERIES = 'batteries'
export const CACHE_KEY_BATTERY_BANK_EFFICIENCY = 'battery-bank-efficiency'
export const CACHE_KEY_BATTERY_BANK_SOH = 'battery-bank-soh'
export const CACHE_KEY_BATTERY_BANK_STATUS = 'battery-bank-status'
export const CACHE_KEY_BATTERY_BANKS = 'battery-banks'
export const CACHE_KEY_BATTERY_BANKS_SIMPLE = 'battery-banks-simple'
export const CACHE_KEY_BIOGAS = 'biogas'
export const CACHE_KEY_BIOGAS_SIMPLE = 'biogas-simple'
export const CACHE_KEY_CHANGEOVER_SWITCHES = 'changeover-switches'
export const CACHE_KEY_COUNTRIES_WITH_SITE_COUNTS = 'countries-with-site-counts'
export const CACHE_KEY_DSM = 'dsm'
export const CACHE_KEY_ENERGY_CONSUMERS = 'energy-consumers'
export const CACHE_KEY_ENERGY_CONSUMERS_SIMPLE = 'energy-consumers-simple'
export const CACHE_KEY_FEATURE_COSTS = 'feature-costs'
export const CACHE_KEY_FEATURE_DSM = 'feature-dsm'
export const CACHE_KEY_FEATURE_NERC = 'feature-nerc'
export const CACHE_KEY_FUEL_AUDIT = 'fuel-audit'
export const CACHE_KEY_FUEL_AUDIT_LATEST_RECORD = 'fuel-audit-latest-record'
export const CACHE_KEY_FUEL_AUDIT_SUMMARIES = 'fuel-audit-summaries'
export const CACHE_KEY_GENERATORS = 'generators'
export const CACHE_KEY_GENERATORS_SIMPLE = 'generators-simple'
export const CACHE_KEY_HAS_THREE_PHASE = 'has-three-phase'
export const CACHE_KEY_HYDRO = 'hydro'
export const CACHE_KEY_HYDRO_SIMPLE = 'hydro-simple'
export const CACHE_KEY_INSIGHTS = 'insights'
export const CACHE_KEY_IN_USE = 'in-use'
export const CACHE_KEY_INVERTERS = 'inverters'
export const CACHE_KEY_MANAGED_FUEL_COST = 'managed-fuel-cost'
export const CACHE_KEY_MESSAGE_RECIPIENTS = 'message-recipients'
export const CACHE_KEY_MONITOR_TYPES = 'monitor-types'
export const CACHE_KEY_MONITORS = 'monitors'
export const CACHE_KEY_MONITORS_HISTORY = 'monitors-history'
export const CACHE_KEY_NOTIFICATIONS = 'notifications'
export const CACHE_KEY_OPEN_ALERTS = 'open-alerts'
export const CACHE_KEY_ORGANISATION_ALERT_DEFINITIONS = 'organisation-alert-definitions'
export const CACHE_KEY_ORGANISATION_SETTINGS = 'organisation-settings'
export const CACHE_KEY_ORGANISATIONS = 'organisations'
export const CACHE_KEY_PARTNERS = 'partners'
export const CACHE_KEY_POWER_GRIDS = 'power-grids'
export const CACHE_KEY_POWER_GRIDS_SIMPLE = 'power-grids-simple'
export const CACHE_KEY_RULE_SETTINGS = 'rule-settings'
export const CACHE_KEY_SHELLY_STATES = 'shelly-states'
export const CACHE_KEY_SITE_ALERT_DEFINITIONS = 'site-alert-definitions'
export const CACHE_KEY_SITE_SETTINGS = 'site-settings'
export const CACHE_KEY_SITE_SYSTEM = 'site-system'
export const CACHE_KEY_SITES = 'sites'
export const CACHE_KEY_SITES_CONNECTIONS = 'sites-connections'
export const CACHE_KEY_SITES_COUNTS = 'sites-counts'
export const CACHE_KEY_SITES_DSM_CONFIGURATION = 'dsm-configuration'
export const CACHE_KEY_SITES_FOR_DASHBOARD = 'sites-for-dashboard'
export const CACHE_KEY_SITES_WITH_CRITICAL_ALERTS_COUNT = 'sites-with-critical-alerts-count'
export const CACHE_KEY_SITES_WITH_HIGH_ALERTS_COUNT = 'sites-with-high-alerts-count'
export const CACHE_KEY_SOLAR_PV = 'solar-pv'
export const CACHE_KEY_SOLAR_PV_SIMPLE = 'solar-pv-simple'
export const CACHE_KEY_STRATEGY_RUNS = 'strategy-runs'
export const CACHE_KEY_TIER_STATES = 'tier-states'
export const CACHE_KEY_USER_RECORDS = 'user-records'
export const CACHE_KEY_USER_SETTINGS = 'user-settings'
export const CACHE_KEY_WIND = 'wind'
export const CACHE_KEY_WIND_SIMPLE = 'wind-simple'

// Analytics
export const CACHE_KEY_AC_ASSET_FAMILY_COST_OF_ENERGY = 'ac-asset-family-cost-of-energy'
export const CACHE_KEY_AC_ASSET_FAMILY_DC_CURRENT_AND_VOLTAGE = 'ac-asset-family-dc-current-and-voltage'
export const CACHE_KEY_AC_ASSET_FAMILY_ENERGY_MONTHLY = 'ac-asset-family-energy-monthly'
export const CACHE_KEY_AC_ASSET_FAMILY_SUMMARY = 'ac-asset-family-summary'
export const CACHE_KEY_ANALYTICS = 'analytics'
export const CACHE_KEY_ASSET_FAMILY_GROUP_ENERGY = 'asset-family-group-energy'
export const CACHE_KEY_ASSET_FAMILY_GROUP_ENERGY_MONTHLY = 'asset-family-group-energy-monthly'
export const CACHE_KEY_ASSET_FAMILY_GROUP_MEMBERS = 'asset-family-group-members'
export const CACHE_KEY_ASSET_FAMILY_GROUP_POWER = 'asset-family-group-power'
export const CACHE_KEY_BATTERY_BANK_ENERGY = 'battery-bank-energy'
export const CACHE_KEY_BATTERY_DETAIL = 'battery-detail'
export const CACHE_KEY_CURRENT_AND_VOLTAGE = 'current-and-voltage'
export const CACHE_KEY_DEPTH_OF_DISCHARGE = 'depth-of-discharge'
export const CACHE_KEY_ENERGY = 'energy'
export const CACHE_KEY_ENERGY_EFFICIENCY = 'energy-efficiency'
export const CACHE_KEY_FUEL_CONSUMPTION = 'fuel-consumption'
export const CACHE_KEY_GRID_SEVEN_DAY_ROLLING_AVERAGE = 'grid-seven-day-rolling-average'
export const CACHE_KEY_MIN_MAX = 'min-max'
export const CACHE_KEY_ORGANISATION_CO2E = 'organisation-co2e'
export const CACHE_KEY_ORGANISATION_COST_OF_ENERGY = 'organisation-cost-of-energy'
export const CACHE_KEY_ORGANISATION_TOTAL_BIOGAS_POWER = 'organisation-total-biogas-power'
export const CACHE_KEY_ORGANISATION_TOTAL_CONSUMPTION = 'organisation-total-consumption'
export const CACHE_KEY_ORGANISATION_TOTAL_ENERGY = 'organisation-total-energy'
export const CACHE_KEY_ORGANISATION_TOTAL_GENERATION = 'organisation-total-generation'
export const CACHE_KEY_ORGANISATION_TOTAL_GENERATOR_POWER = 'organisation-total-generator-power'
export const CACHE_KEY_ORGANISATION_TOTAL_GRID_POWER = 'organisation-total-grid-power'
export const CACHE_KEY_ORGANISATION_TOTAL_HYDRO_POWER = 'organisation-total-hydro-power'
export const CACHE_KEY_ORGANISATION_TOTAL_INSTALLED_CAPACITY = 'organisation-total-installed-capacity'
export const CACHE_KEY_ORGANISATION_TOTAL_SOLAR_PV_POWER = 'organisation-total-solar-pv-power'
export const CACHE_KEY_ORGANISATION_TOTAL_STORAGE = 'organisation-total-storage'
export const CACHE_KEY_ORGANISATION_TOTAL_WIND_POWER = 'organisation-total-wind-power'
export const CACHE_KEY_PHASE_DURATION_AVERAGES = 'phase-duration-averages'
export const CACHE_KEY_PHASE_DURATION_HISTOGRAM = 'phase-duration-histogram'
export const CACHE_KEY_PHASE_DURATION_TOTALS = 'phase-duration-totals'
export const CACHE_KEY_PHASE_STATISTICS = 'phase-statistics'
export const CACHE_KEY_POWER_GRID_AVAILABILITY_TIMES = 'power-grid-availability-times'
export const CACHE_KEY_POWER_PROFILE = 'power-profile'
export const CACHE_KEY_RUNTIME = 'runtime'
export const CACHE_KEY_SITE_AC_ENERGY_CONSUMERS = 'site-ac-energy-consumers'
export const CACHE_KEY_SITE_AC_GENERATORS = 'site-ac-generators'
export const CACHE_KEY_SITE_AMBIENT_TEMPERATURE = 'site-ambient-temperature'
export const CACHE_KEY_SITE_CARD = 'site-card'
export const CACHE_KEY_SITE_CO2E_DETAILS = 'site-co2e-details'
export const CACHE_KEY_SITE_COST_OF_ENERGY = 'site-cost-of-energy'
export const CACHE_KEY_SITE_COST_OF_ENERGY_DETAILS = 'site-cost-of-energy-details'
export const CACHE_KEY_SITE_COSTS_AND_EMISSIONS_BY_KILOWATT_HOUR = 'site-costs-and-emissions-by-kilowatt-hour'
export const CACHE_KEY_SITE_COSTS_AND_EMISSIONS_BY_TYPE = 'site-costs-and-emissions-by-type'
export const CACHE_KEY_SITE_DC_STORAGE = 'site-dc-storage'
export const CACHE_KEY_SITE_ENERGY = 'site-energy'
export const CACHE_KEY_SITE_ENERGY_GENERATED_BY_TYPE = 'site-energy-generated-by-type'
export const CACHE_KEY_SITE_FLOW = 'site-flow'
export const CACHE_KEY_SITE_FUEL_LEVEL = 'site-fuel-level'
export const CACHE_KEY_SITE_FUEL_THROUGHPUT = 'site-fuel-throughput'
export const CACHE_KEY_SITE_GROUPS = 'site-groups'
export const CACHE_KEY_SITE_LONG_TERM_FORECAST = 'site-long-term-forecast'
export const CACHE_KEY_SITE_MIN_MAX_POWER = 'site-min-max-power'
export const CACHE_KEY_SITE_NERC_TARIFF_BAND_COMPLIANCE = 'site-nerc-tariff-band-compliance'
export const CACHE_KEY_SITE_PEAK_POWER = 'site-peak-power'
export const CACHE_KEY_SITE_POWER = 'site-power'
export const CACHE_KEY_SITE_RUN_TIMES = 'site-run-times'
export const CACHE_KEY_SITE_RUN_TIMES_BY_TYPE = 'site-run-times-by-type'
export const CACHE_KEY_SITE_SHORT_TERM_FORECAST = 'site-short-term-forecast'
export const CACHE_KEY_SITE_TOTAL_ENERGY_DETAILS = 'site-total-energy-details'
export const CACHE_KEY_SITE_UP_TIME = 'site-up-time'
export const CACHE_KEY_STATE_OF_CHARGE = 'state-of-charge'

// Monitor Types
export const CACHE_KEY_BATTERY = 'battery'
export const CACHE_KEY_BATTERY_BANK = 'battery-bank'
export const CACHE_KEY_ENERGY_CONSUMER = 'energy-consumer'
export const CACHE_KEY_GENERATOR = 'generator'
export const CACHE_KEY_INVERTER = 'inverter'
export const CACHE_KEY_POWER_GRID = 'power-grid'
export const CACHE_KEY_SITE = 'site'

// Partner Access
export const CACHE_KEY_PARTNER_ACCESS = 'partner-access'

// Generic
export const CACHE_KEY_API_KEY = 'api-key'
export const CACHE_KEY_COUNTRIES = 'countries'
export const CACHE_KEY_COUNT = 'count'
export const CACHE_KEY_CURRENCIES = 'currencies'
export const CACHE_KEY_CURRENT = 'current'
export const CACHE_KEY_DASHBOARD = 'dashboard'
export const CACHE_KEY_EXPORTS = 'exports'
export const CACHE_KEY_LAST_UPDATED = 'last-updated'
export const CACHE_KEY_LATEST_READINGS = 'latest-reading'
export const CACHE_KEY_LIST = 'list'
export const CACHE_KEY_ODYSSEY_URL = 'odyssey-url'
export const CACHE_KEY_RECIPIENTS = 'recipients'
export const CACHE_KEY_REPORTS = 'reports'
export const CACHE_KEY_REPORT_RECIPIENTS = 'report-recipients'
export const CACHE_KEY_UNASSIGNED_MONITOR_READINGS = 'unassigned-monitor-readings'
export const CACHE_KEY_USER = 'user'

// keys
export const CACHE_KEY_CONNECTION_ID = 'connection-id'
export const CACHE_KEY_CONNECTION_SECRET = 'connection-secret'
